import { Link } from 'react-router-dom';
import { useTheme } from '@/hooks/useTheme';

export default function Footer() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <footer className={`border-t font-inter transition-colors duration-300 ${isDark ? 'bg-[#0F172A] border-white/10' : 'bg-white border-[#E2E8F0]'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-5">
              <div className="w-[72px] h-[72px] flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/cec110ae-2ba1-4571-aeb1-a9f5a3600a20.png"
                  alt="PureHomeScale"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <p className={`text-sm leading-relaxed mb-6 ${isDark ? 'text-white/35' : 'text-[#334155]/60'}`}>
              AI-powered growth systems for home service businesses. Built to capture every lead and convert it into revenue.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className={`w-8 h-8 flex items-center justify-center rounded-full border transition-all duration-200 cursor-pointer ${isDark ? 'border-white/15 text-white/40 hover:text-white hover:border-white/40' : 'border-[#E2E8F0] text-[#334155]/40 hover:text-[#0F172A] hover:border-[#334155]/40'}`}>
                <i className="ri-twitter-x-line text-xs"></i>
              </a>
              <a href="#" className={`w-8 h-8 flex items-center justify-center rounded-full border transition-all duration-200 cursor-pointer ${isDark ? 'border-white/15 text-white/40 hover:text-white hover:border-white/40' : 'border-[#E2E8F0] text-[#334155]/40 hover:text-[#0F172A] hover:border-[#334155]/40'}`}>
                <i className="ri-linkedin-line text-xs"></i>
              </a>
              <a href="#" className={`w-8 h-8 flex items-center justify-center rounded-full border transition-all duration-200 cursor-pointer ${isDark ? 'border-white/15 text-white/40 hover:text-white hover:border-white/40' : 'border-[#E2E8F0] text-[#334155]/40 hover:text-[#0F172A] hover:border-[#334355]/40'}`}>
                <i className="ri-youtube-line text-xs"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className={`font-semibold text-sm mb-5 font-poppins ${isDark ? 'text-white/90' : 'text-[#0F172A]'}`}>Services</h4>
            <ul className="space-y-3">
              {['AI Call Handling', 'Lead Response', 'Automated Booking', 'Smart Follow-Up', 'Pipeline Visibility'].map((item) => (
                <li key={item}>
                  <a href="#" className={`text-sm transition-colors duration-200 cursor-pointer ${isDark ? 'text-white/35 hover:text-white/70' : 'text-[#334155]/60 hover:text-[#0F172A]'}`}>{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className={`font-semibold text-sm mb-5 font-poppins ${isDark ? 'text-white/90' : 'text-[#0F172A]'}`}>Industries</h4>
            <ul className="space-y-3">
              {['HVAC', 'Plumbing', 'Roofing', 'Electrical', 'General Contractors'].map((item) => (
                <li key={item}>
                  <Link to="/industries" className={`text-sm transition-colors duration-200 cursor-pointer ${isDark ? 'text-white/35 hover:text-white/70' : 'text-[#334155]/60 hover:text-[#0F172A]'}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className={`font-semibold text-sm mb-5 font-poppins ${isDark ? 'text-white/90' : 'text-[#0F172A]'}`}>Company</h4>
            <ul className="space-y-3">
              {[
                { label: 'Case Studies', to: '/case-studies' },
                { label: 'Industries', to: '/industries' },
                { label: 'Contact', to: '/contact' },
                { label: 'Book Demo', to: '/#book-demo' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className={`text-sm transition-colors duration-200 cursor-pointer ${isDark ? 'text-white/35 hover:text-white/70' : 'text-[#334155]/60 hover:text-[#0F172A]'}`}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={`mt-16 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-4 ${isDark ? 'border-white/8' : 'border-[#E2E8F0]'}`}>
          <p className={`text-xs ${isDark ? 'text-white/25' : 'text-[#334155]/40'}`}>&copy; 2026 PureHomeScale. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className={`text-xs transition-colors duration-200 cursor-pointer ${isDark ? 'text-white/25 hover:text-white/50' : 'text-[#334155]/40 hover:text-[#0F172A]'}`}>Privacy Policy</a>
            <a href="#" className={`text-xs transition-colors duration-200 cursor-pointer ${isDark ? 'text-white/25 hover:text-white/50' : 'text-[#334155]/40 hover:text-[#0F172A]'}`}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}